<template lang="pug">
div(@mouseover='hovered = true', @mouseout='hovered = false',)
  .background(
    v-bind:style="{ backgroundImage: 'url(' + flixel.thumbnail + ')' }",
    :class="( flixel.width > flixel.height ) ? 'landscape' : 'portrait' "
  )
  a.hide-desktop.link_overlay(@click='goToFlixel(flixel.hash, flixels, index)')
  a.hide-mobile.link_overlay(@click='goToFlixel(flixel.hash, flixels, index)')
  iframe(:src='flixel.player_url', v-if='hovered' allow='autoplay')
</template>

<script>

export default {
  name: 'FlixelListProfile',
  props: ['flixel', 'index', 'flixels'],
  data() {
    return {
      hovered: false,
    };
  },
  methods: {
    goToFlixel(hash, flixels, index) {
      this.$router.push({
        name: 'Flixel',
        params: {
          hash: this.flixel.hash,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FlixelListProfile.vue